export const EXTRA_FIELDS = [
  {
    id: "is_primary",
    name: "Is a primary point of contact?",
    type: "checkbox",
    settings: {},
    required: false
  }
];
